/**
 * Grouping helpers for the shareholding pattern and shareholder KYC steps.
 *
 * The rules themselves live on the backend: each row carries `kyc_required` and
 * `requires_own_shareholders`, and the remaining gaps come from
 * GET /v1/kyc/shareholder/coverage. Nothing here re-decides any of that.
 *
 * A loan has shareholders of the borrower company, and each business shareholder
 * has its own individual shareholders. `business_shareholder` holds the uuid of
 * the company a person holds shares in, and is empty for the borrower company.
 */

export const borrowerShareholders = (shareholders = []) =>
  shareholders.filter((row) => !row.business_shareholder);

export const shareholdersOf = (shareholders = [], company) =>
  shareholders.filter((row) => row.business_shareholder === company?.uuid);

// Mirrors the backend's MIN_DECLARED_SHAREHOLDING / MAX_DECLARED_SHAREHOLDING
// (src/kyc/constants.py): each business shareholder's own owners must add up
// to at least this much, and no more than this much.
export const MIN_OWNER_DECLARATION = 50;
export const MAX_OWNER_DECLARATION = 100;

// Percentages are stored to two decimal places, so they are summed as whole
// hundredths. Adding them as fractions lets binary rounding drift into totals
// like 67.00999999999999.
export const totalHolding = (rows = []) =>
  rows.reduce(
    (total, row) => total + Math.round(Number(row.shareholding_percentage || 0) * 100),
    0
  ) / 100;
